// extracted by mini-css-extract-plugin
module.exports = {"input":"NewFormInput_input__yUoKD","clear_action":"NewFormInput_clear_action__ZPpUu","disabled":"NewFormInput_disabled__IYx_s","label_text":"NewFormInput_label_text__HCx5E"};